const contacts = [
  {
    id: '65c4e8f9-8dea-4257-b578-0eb1334135b8',
    accounts: [
      {
        bic: null,
        iban: 'BA23ABNB8C51FDCCD2',
        name: 'savings account',
        alias: null,
        accountNumber: 'a9a9150902',
        IBAN: 'BA23ABNB8C51FDCCD2',
        BIC: null,
        bankCode: '6781ea',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'GABRIELA PATRICIA FIELD BRISEÑO',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Gabriela.field@outlook.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: 'RNC', idNumber: '509' },
  },
  {
    id: '9c9f0942-c3d2-4c34-b48f-6317ed7ae64f',
    accounts: [
      {
        bic: null,
        iban: '9909ABN8600DA5C122',
        name: 'savings account',
        alias: null,
        accountNumber: '40ec7362e1',
        IBAN: '9909ABN8600DA5C122',
        BIC: null,
        bankCode: '04af48',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'ISIDORA DANIELA CARROCERA MANJARREZ',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Isidora.carrocera@altavista.net',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: 'CIP', idNumber: '26f' },
  },
  {
    id: '137dec18-2a38-4081-a37e-961a0cb901ad',
    accounts: [
      {
        bic: null,
        iban: '8819ABN8080A143DC8',
        name: 'savings account',
        alias: null,
        accountNumber: '02e2d82073',
        IBAN: '8819ABN8080A143DC8',
        BIC: null,
        bankCode: 'f28089',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'ANTHONY TOMÁS SANTIAGO CASTRO GALÁN',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Anthony.castro@apple.com.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: 'PAS', idNumber: '3a8' },
  },
  {
    id: '7a68bf10-bca1-4ed7-9179-4d84bf191e87',
    accounts: [
      {
        bic: null,
        iban: '9BA6ABN845D183AFA4',
        name: 'savings account',
        alias: null,
        accountNumber: 'fd343a5fbe',
        IBAN: '9BA6ABN845D183AFA4',
        BIC: null,
        bankCode: 'af9189',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'OLIVIA GOMEZ MENDIZÁBAL',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Olivia.gomez@protonmail.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0fe2c', idNumber: 'cc9' },
  },
  {
    id: 'fe0a1c73-d7d1-425a-aeb9-e1a1108ad6ca',
    accounts: [
      {
        bic: null,
        iban: '9924ABNAB450272CE0',
        name: 'savings account',
        alias: null,
        accountNumber: 'e21deccdcd',
        IBAN: '9924ABNAB450272CE0',
        BIC: null,
        bankCode: 'e9ad5b',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'RAMÓN IAN JOSÉ CARDONA CIGARROA',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Ramón.cardona@aol.us',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '078e0', idNumber: '537' },
  },
  {
    id: 'bfcc86c2-63b3-4ac5-9c13-61a5d023717b',
    accounts: [
      {
        bic: null,
        iban: 'BB4DABN8E3E90DC2FD',
        name: 'savings account',
        alias: null,
        accountNumber: '94e75760ad',
        IBAN: 'BB4DABN8E3E90DC2FD',
        BIC: null,
        bankCode: 'e5937a',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'GREGORIO ANTHONY ROSALES BARRETO',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Gregorio.rosales@apple.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '04edd', idNumber: 'f6a' },
  },
  {
    id: '15a0fe72-a403-4029-a901-182a1e4a1ea4',
    accounts: [
      {
        bic: null,
        iban: 'AB78ABN8C433EE0085',
        name: 'savings account',
        alias: null,
        accountNumber: 'dc46e80267',
        IBAN: 'AB78ABN8C433EE0085',
        BIC: null,
        bankCode: '6cab98',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'CARIDAD NATHAL BURGOS',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Caridad.nathal@icloud.com.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0fe5d', idNumber: '454' },
  },
  {
    id: '9edb0b89-a381-4bdf-b01f-df0f5bc17691',
    accounts: [
      {
        bic: null,
        iban: 'AA18ABN8724F96AF4D',
        name: 'savings account',
        alias: null,
        accountNumber: '335ac27374',
        IBAN: 'AA18ABN8724F96AF4D',
        BIC: null,
        bankCode: 'b29e1b',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'ALTAGRACIA FRANCESCA SALOMÉ PRAVIN GRACIA',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Altagracia.pravin@protonmail.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '05d58', idNumber: '1dd' },
  },
  {
    id: 'fd6f565e-d4e5-42f1-8054-0a43459a035c',
    accounts: [
      {
        bic: null,
        iban: 'B891ABN9E834E0AB7F',
        name: 'savings account',
        alias: null,
        accountNumber: 'c1e155c127',
        IBAN: 'B891ABN9E834E0AB7F',
        BIC: null,
        bankCode: '5fa5da',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'ANTONELLA YANKELEVICH MAYORAL',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Antonella.yankelevich@yahoo.com',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '04ca8', idNumber: '1c5' },
  },
  {
    id: 'c7c8172b-241c-4b29-98a7-cf4f94689d2d',
    accounts: [
      {
        bic: null,
        iban: 'B9B9ABNA25A39F947F',
        name: 'savings account',
        alias: null,
        accountNumber: 'a7e5a76236',
        IBAN: 'B9B9ABNA25A39F947F',
        BIC: null,
        bankCode: '8a8639',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'SAMUEL LIAN SCHMULSON GALLO',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Samuel.schmulson@aol.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '01e75', idNumber: 'c79' },
  },
  {
    id: '650015f4-13db-4893-beba-7416d52f6c72',
    accounts: [
      {
        bic: null,
        iban: '99F7ABNA24D6A5DFDA',
        name: 'savings account',
        alias: null,
        accountNumber: '55663b296d',
        IBAN: '99F7ABNA24D6A5DFDA',
        BIC: null,
        bankCode: '809438',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'RAÚL JOSUÉ PEDRO FALOMIR PERICHART',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Raúl.falomir@zoho.com',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '03105', idNumber: 'dc2' },
  },
  {
    id: '5d381ab3-855b-4b2a-88c1-63f321ed4c5f',
    accounts: [
      {
        bic: null,
        iban: '9935ABNB33E8DAC854',
        name: 'savings account',
        alias: null,
        accountNumber: '2fd99b9d32',
        IBAN: '9935ABNB33E8DAC854',
        BIC: null,
        bankCode: 'f5bb4a',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'ERIK HUGO LIAN HERZBERG SALGADO',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Erik.herzberg@apple.es',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0da3d', idNumber: '664' },
  },
  {
    id: '45404b12-eb3b-4c75-8569-e7356e972bf0',
    accounts: [
      {
        bic: null,
        iban: 'A986ABNAF92F2A21DE',
        name: 'savings account',
        alias: null,
        accountNumber: '84393a2d1a',
        IBAN: 'A986ABNAF92F2A21DE',
        BIC: null,
        bankCode: '71ad1a',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'CÉSAR ALBERTO TOMÁS PIZANO ÁNGELES',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'César.pizano@aol.com.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0c319', idNumber: '4ca' },
  },
  {
    id: '7d982230-fdaf-4d53-be59-c8db9fce0dc7',
    accounts: [
      {
        bic: null,
        iban: 'AA16ABN8394AA71337',
        name: 'savings account',
        alias: null,
        accountNumber: '1e91de53d7',
        IBAN: 'AA16ABN8394AA71337',
        BIC: null,
        bankCode: 'a198ba',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'REINA FAJARDO ÁLVAREZ',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Reina.fajardo@protonmail.es',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '01f37', idNumber: 'e1c' },
  },
  {
    id: '218cb902-2b30-4982-9c92-eb432ad49e43',
    accounts: [
      {
        bic: null,
        iban: '88E6ABN9EE071B74FE',
        name: 'savings account',
        alias: null,
        accountNumber: '296a65ee26',
        IBAN: '88E6ABN9EE071B74FE',
        BIC: null,
        bankCode: '9aa65a',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'CARLOS JAYDEN JORGE TOMOKA OLIVARES',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Carlos.tomoka@america.com.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '09060', idNumber: '319' },
  },
  {
    id: '9056f516-70c3-401e-9ab4-48e822a2b10a',
    accounts: [
      {
        bic: null,
        iban: '99ECABN9DC42331907',
        name: 'savings account',
        alias: null,
        accountNumber: 'ab2a84b88d',
        IBAN: '99ECABN9DC42331907',
        BIC: null,
        bankCode: 'a6b768',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'ANDRÉS NOAH VILLA VÁSQUEZ',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Andrés.villa@zoho.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '09fc2', idNumber: 'bdf' },
  },
  {
    id: 'a41ff4e0-7914-48f3-9b4d-39862fd0ad51',
    accounts: [
      {
        bic: null,
        iban: '8832ABN8798F2FC2DF',
        name: 'savings account',
        alias: null,
        accountNumber: '85a034d739',
        IBAN: '8832ABN8798F2FC2DF',
        BIC: null,
        bankCode: '0da3eb',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'TRINIDAD ALANA DECANINI VIDAURRETA',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Trinidad.decanini@aol.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0ee2b', idNumber: '197' },
  },
  {
    id: 'cf39d363-4290-42fb-9ede-d24ac3a4879d',
    accounts: [
      {
        bic: null,
        iban: 'BBA7ABNADB5F61D2E0',
        name: 'savings account',
        alias: null,
        accountNumber: '214279d9a1',
        IBAN: 'BBA7ABNADB5F61D2E0',
        BIC: null,
        bankCode: 'd0a2eb',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'EMILY CASTAÑEDA COLMENERO',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Emily.castañeda@gmail.us',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '050b4', idNumber: '638' },
  },
  {
    id: '16784f70-8846-40e1-a0ea-996a16b3b2b3',
    accounts: [
      {
        bic: null,
        iban: '99D7ABNBF32163412B',
        name: 'savings account',
        alias: null,
        accountNumber: 'a47b9da577',
        IBAN: '99D7ABNBF32163412B',
        BIC: null,
        bankCode: 'c8bb48',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'MANUEL VILLASEÑOR BELTRÁN',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Manuel.villaseñor@zoho.es',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '02cf5', idNumber: '2ad' },
  },
  {
    id: '3d3b92b2-a523-43d3-a792-25003c1ee70a',
    accounts: [
      {
        bic: null,
        iban: '9A9BABNBAF2EE76475',
        name: 'savings account',
        alias: null,
        accountNumber: '4d2ee6bc1d',
        IBAN: '9A9BABNBAF2EE76475',
        BIC: null,
        bankCode: 'c1a3c9',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'ALONSO CARLOS NAVARRO PÉREZ',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Alonso.navarro@outlook.us',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '073bc', idNumber: 'f66' },
  },
  {
    id: 'e2b9ec18-8090-40ed-b47d-86d9ae6306e2',
    accounts: [
      {
        bic: null,
        iban: '99FFABN9F6A1D769D2',
        name: 'savings account',
        alias: null,
        accountNumber: 'f30cd8d0ae',
        IBAN: '99FFABN9F6A1D769D2',
        BIC: null,
        bankCode: '80aec9',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'MARTÍN ALBERTO JULIO MEMIJE OSTROSKY',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Martín.memije@altavista.es',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0e423', idNumber: '239' },
  },
  {
    id: '7b281414-f69f-40c9-85d0-0063b7ec8958',
    accounts: [
      {
        bic: null,
        iban: 'BB59ABNB6BA3A11B9A',
        name: 'savings account',
        alias: null,
        accountNumber: 'da796c2d6f',
        IBAN: 'BB59ABNB6BA3A11B9A',
        BIC: null,
        bankCode: '4d8ef9',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'YAMILETH BARRIGUETE SANTAMARÍA',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Yamileth.barriguete@yahoo.com.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0ceb3', idNumber: '4e2' },
  },
  {
    id: '7125a672-eec4-4b5c-adfd-9aa56ec33701',
    accounts: [
      {
        bic: null,
        iban: '9A2CABNBF15F38612D',
        name: 'savings account',
        alias: null,
        accountNumber: '7a9551f3a4',
        IBAN: '9A2CABNBF15F38612D',
        BIC: null,
        bankCode: 'bf8119',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'AGUSTINA BRIANA Y RODRÍGUEZ CHAPULA',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Agustina.y rodríguez@gmail.com',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: 'CIP', idNumber: 'b01' },
  },
  {
    id: 'b942d012-d061-438d-a214-92eb37c24df7',
    accounts: [
      {
        bic: null,
        iban: 'AA2EABNBA00BABD700',
        name: 'savings account',
        alias: null,
        accountNumber: '101b0479f2',
        IBAN: 'AA2EABNBA00BABD700',
        BIC: null,
        bankCode: '5b89ea',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'SEBASTIÁN LUIS LIMA EXAIRE',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Sebastián.lima@amazon.net',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0002d', idNumber: 'e86' },
  },
  {
    id: 'd1c06d93-b943-46e1-bdf6-d996b9f8f17e',
    accounts: [
      {
        bic: null,
        iban: 'BB9DABNABD810F3399',
        name: 'savings account',
        alias: null,
        accountNumber: 'f17e649800',
        IBAN: 'BB9DABNABD810F3399',
        BIC: null,
        bankCode: 'f39e19',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'BENICIO OSCAR NUEVO GRAEF',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Benicio.nuevo@icloud.net',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '05921', idNumber: 'b46' },
  },
  {
    id: '3951c452-7b12-4da0-b237-9b064ba2ac8d',
    accounts: [
      {
        bic: null,
        iban: '99B7ABNAEA6BBD6BC5',
        name: 'savings account',
        alias: null,
        accountNumber: '0a228fe226',
        IBAN: '99B7ABNAEA6BBD6BC5',
        BIC: null,
        bankCode: 'c692c8',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'MARIAPAZ REINA ALTAMIRANO SÁNCHEZ',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Mariapaz.altamirano@zoho.es',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0dd75', idNumber: 'd42' },
  },
  {
    id: '8be87c92-a446-4658-8566-a82dddf89176',
    accounts: [
      {
        bic: null,
        iban: 'AB21ABN89D6ED9C279',
        name: 'savings account',
        alias: null,
        accountNumber: '5351561295',
        IBAN: 'AB21ABN89D6ED9C279',
        BIC: null,
        bankCode: '62ad98',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'FÉLIX JEREMY GIRÓN CHAN',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Félix.girón@icloud.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '04b21', idNumber: 'bc8' },
  },
  {
    id: '895b9807-2b6d-4194-a33a-bcaae6b7eb53',
    accounts: [
      {
        bic: null,
        iban: 'BB63ABN8742B5862FC',
        name: 'savings account',
        alias: null,
        accountNumber: '780c5ee1b1',
        IBAN: 'BB63ABN8742B5862FC',
        BIC: null,
        bankCode: '7db478',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'ASHLEY ROSMERY MAITE CALLEROS LOZANO',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Ashley.calleros@gmail.us',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '09b98', idNumber: '22e' },
  },
  {
    id: '36f1d9f7-bcc9-4025-bea7-621c9df6fd99',
    accounts: [
      {
        bic: null,
        iban: '88B6ABN99A8F4C8C99',
        name: 'savings account',
        alias: null,
        accountNumber: 'ce2b80c97d',
        IBAN: '88B6ABN99A8F4C8C99',
        BIC: null,
        bankCode: 'aebd28',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'ALBERTO DUQUE RAMÍREZ',
    alias: 'duke',
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Alberto.duque@altavista.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '00212', idNumber: '0d3' },
  },
  {
    id: '47d9b8c6-b180-451a-afeb-3aa118df6808',
    accounts: [
      {
        bic: null,
        iban: 'B8C1ABNA98365A89F6',
        name: 'savings account',
        alias: null,
        accountNumber: 'c7a10f1d32',
        IBAN: 'B8C1ABNA98365A89F6',
        BIC: null,
        bankCode: 'c8b828',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'ALEJANDRO CESAR CRISTÓBAL FILIZOLA ZÁRATE',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Alejandro.filizola@amazon.com.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '00e0a', idNumber: 'c1b' },
  },
  {
    id: '5daeae4a-020f-47ef-be20-3cf0a20408fa',
    accounts: [
      {
        bic: null,
        iban: 'B868ABN901752EA696',
        name: 'savings account',
        alias: null,
        accountNumber: 'd845a26dfe',
        IBAN: 'B868ABN901752EA696',
        BIC: null,
        bankCode: 'e2bd28',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'MARIO MANUEL ANDRÉS ROSALES LÓPEZ',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Mario.rosales@america.com',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0a0df', idNumber: '6d4' },
  },
  {
    id: '5b1e154e-948a-4542-9798-6bbb6841c2a7',
    accounts: [
      {
        bic: null,
        iban: 'A82EABN9BEF69D2197',
        name: 'savings account',
        alias: null,
        accountNumber: '295cdc7630',
        IBAN: 'A82EABN9BEF69D2197',
        BIC: null,
        bankCode: '17927b',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'JUSTIN CHICO BARINAGARREMENTERÍA',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Justin.chico@gmail.com.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0dee7', idNumber: 'b20' },
  },
  {
    id: 'b7db514f-871b-4bb1-a415-977f36ef9256',
    accounts: [
      {
        bic: null,
        iban: 'B8EEABNBBBC370720F',
        name: 'savings account',
        alias: null,
        accountNumber: '27d2104a41',
        IBAN: 'B8EEABNBBBC370720F',
        BIC: null,
        bankCode: 'bfb24a',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'BENJAMÍN JOAQUÍN ROLANDO ZÁRATE JERJES-SÁNCHEZ',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Benjamín.zárate@america.us',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0071b', idNumber: '4d3' },
  },
  {
    id: 'b4d3d052-e053-458f-b1c4-48f986f36125',
    accounts: [
      {
        bic: null,
        iban: '9AF2ABNA0B9EE4ED16',
        name: 'savings account',
        alias: null,
        accountNumber: '7dfa68e339',
        IBAN: '9AF2ABNA0B9EE4ED16',
        BIC: null,
        bankCode: '25a428',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'CARMEN ANA AMARO ROMERO',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Carmen.amaro@amazon.com.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '038b0', idNumber: '2f2' },
  },
  {
    id: '932b99fc-5fc5-4fb2-8cf2-f0aeedcc8640',
    accounts: [
      {
        bic: null,
        iban: 'A914ABN8BFC0967368',
        name: 'savings account',
        alias: null,
        accountNumber: '59f462f1e9',
        IBAN: 'A914ABN8BFC0967368',
        BIC: null,
        bankCode: 'fa883a',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'VÍCTOR LIAM FALOMIR VALDOVINOS',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Víctor.falomir@apple.us',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '07a87', idNumber: 'b25' },
  },
  {
    id: '1e9fdba5-1b85-417c-8f51-eede60a2b7c2',
    accounts: [
      {
        bic: null,
        iban: '9A2AABNB58A052E9F5',
        name: 'savings account',
        alias: null,
        accountNumber: 'c556731269',
        IBAN: '9A2AABNB58A052E9F5',
        BIC: null,
        bankCode: 'f6b0f9',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: true,
    name: 'MARCO ERIK MOLINA VILAR',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Marco.molina@aol.com.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '084bf', idNumber: 'c49' },
  },
  {
    id: 'b0d0cf80-cb5f-41be-8c34-34baa7186157',
    accounts: [
      {
        bic: null,
        iban: '9BE7ABNA6DED8449DB',
        name: 'savings account',
        alias: null,
        accountNumber: '3543b57710',
        IBAN: '9BE7ABNA6DED8449DB',
        BIC: null,
        bankCode: '51baea',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'ODALYS MENDIOLEA GARCÍA',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Odalys.mendiolea@america.es',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '099c9', idNumber: 'ceb' },
  },
  {
    id: '8bac4bcc-1965-4ecc-8e51-f76f5e74f882',
    accounts: [
      {
        bic: null,
        iban: 'BA0AABN99C37B18DCC',
        name: 'savings account',
        alias: null,
        accountNumber: 'f926c80a2b',
        IBAN: 'BA0AABN99C37B18DCC',
        BIC: null,
        bankCode: 'f6b90a',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'EVELYN CLAUDIA KIARA QUINTANA OSORIO',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Evelyn.quintana@altavista.us',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '0bff9', idNumber: 'c42' },
  },
  {
    id: '5f853f09-e971-4520-86c3-d9f5d3dfe52a',
    accounts: [
      {
        bic: null,
        iban: '9AFEABNB4137835520',
        name: 'savings account',
        alias: null,
        accountNumber: '1db86ef6b4',
        IBAN: '9AFEABNB4137835520',
        BIC: null,
        bankCode: '8f8a3b',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'ROXANA MURILLO QUIBRERA',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Roxana.murillo@yahoo.mx',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '00932', idNumber: '4b0' },
  },
  {
    id: '5766e889-90d7-4fba-ac3c-bb2c0de09c42',
    accounts: [
      {
        bic: null,
        iban: 'A90EABNA1250603DBC',
        name: 'savings account',
        alias: null,
        accountNumber: '94ace2f950',
        IBAN: 'A90EABNA1250603DBC',
        BIC: null,
        bankCode: '649678',
        bankName: 'BANESCI',
        bankAddressLine1: null,
        bankAddressLine2: null,
        bankStreetName: null,
        bankTown: null,
        bankPostCode: null,
        bankCountrySubDivision: null,
        bankCountry: null,
        accountHolderAddressLine1: null,
        accountHolderAddressLine2: null,
        accountHolderStreetName: null,
        accountHolderTown: null,
        accountHolderPostCode: null,
        accountHolderCountrySubDivision: null,
        accountHolderCountry: null,
        additions: {
          requiresIntermediateBank: true,
          intermediateBankAddressLine1: 'Intermediate Bank Address Line 1',
          intermediateBankBic: 'Intermediate Bank BIC',
          intermediateBankAddressLine2: 'Intermediate Bank Address Line 2',
          intermediateBankTown: 'Intermediate Bank Town',
          currencyCode: 'DOP',
          intermediateBankCountry: 'Intermediate Bank Country',
          productType: null,
        },
      },
    ],
    accessContextScope: 'USER',
    gender: false,
    name: 'MIA ALEJANDRA SIFUENTES CALDERÓN',
    alias: null,
    category: 'banesco',
    contactPerson: null,
    phoneNumber: null,
    emailId: 'Mia.sifuentes@outlook.com',
    addressLine1: null,
    addressLine2: null,
    streetName: null,
    town: null,
    postCode: null,
    countrySubDivision: null,
    country: null,
    activeStatus: 'ACTIVE',
    additions: { idType: '06127', idNumber: 'ebe' },
  },
];

export default contacts;
